import { InjectionToken } from '@angular/core';
import { RouteGroupRule } from './route-group-rule';

/**
 * Injection token for providing SignalR route group rules.
 *
 * Features should provide their own rules using this token with `multi: true`,
 * so the RouteSignalRGroupService can collect all rules from all features.
 *
 * Example usage in a feature module/provider:
 * ```ts
 * {
 *   provide: SIGNALR_ROUTE_RULES,
 *   useFactory: (store: Store, zone: NgZone) => createMyFeatureRules(store, zone),
 *   deps: [Store, NgZone],
 *   multi: true,
 * }
 * ```
 */
export const SIGNALR_ROUTE_RULES = new InjectionToken<RouteGroupRule[][]>('SIGNALR_ROUTE_RULES');

// Important:
// Use this token as a `multi: true` provider so features can register their
// SignalR route rules without the shared SignalR infrastructure importing
// feature code directly. This prevents tight coupling and avoids circular
// evaluation where importing the shared barrel would pull in feature modules
// (and thereby `@era/stores`) during module initialization.
